import { Injectable } from '@angular/core';
import { LmsUserService } from 'lms-api';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../login/login.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(private lmsUserService: LmsUserService, public router: Router, public modalService: NgbModal) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    switch (state.url) {
      default:
        if (!this.lmsUserService.IsLoggedIn) {
          const loginModalRef = this.modalService.open(LoginComponent);
          loginModalRef.result.then(result => {
            return result;
          });
        }
    }

    return true;
  }
}
